import React from "react";
import { useTranslation } from "react-i18next";
import { motion, AnimatePresence } from 'framer-motion';
import { Upload } from 'lucide-react';

const NewFilePopup = ({ show, onClose, onConfirm, fileName }) => {
  const { t } = useTranslation();

  if (!show) return null;

  return (
    <AnimatePresence>
      <div className="fixed inset-0 z-50 overflow-y-auto">
        <div className="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:p-0">
          <motion.div 
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 transition-opacity"
            onClick={onClose}
          >
            <div className="absolute inset-0 bg-gray-900/75 backdrop-blur-sm"></div>
          </motion.div>

          <motion.div 
            initial={{ opacity: 0, scale: 0.95, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.95, y: 20 }}
            transition={{ duration: 0.2 }}
            className="relative inline-block w-full max-w-md p-6 overflow-hidden text-left align-middle transition-all transform bg-white shadow-xl rounded-2xl"
          >
            <div className="text-center">
              <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-red-100 mb-4">
                <Upload className="h-6 w-6 text-red-600" />
              </div>
              
              <h3 className="text-lg font-medium leading-6 text-gray-900 mb-2">
                {t('loadNewFilePopup')}
              </h3>
              
              <div className="mt-2">
                <p className="text-sm text-gray-500">
                  {t('sentenceNewFilePopup')} 
                  <span className="font-semibold text-gray-700">{fileName}</span> 
                  {t('sentenceNewFilePopup2')}
                </p>
              </div>

              <div className="mt-6 flex flex-col sm:flex-row gap-3 justify-center">
                <button
                  onClick={onConfirm}
                  className="inline-flex justify-center px-4 py-2 text-sm font-medium text-white bg-red-600 hover:bg-red-700 rounded-lg focus:outline-none focus-visible:ring-2 focus-visible:ring-red-500 focus-visible:ring-offset-2 transition-colors duration-200"
                >
                  {t('carregar')}
                </button>
                <button
                  onClick={onClose}
                  className="inline-flex justify-center px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg focus:outline-none focus-visible:ring-2 focus-visible:ring-gray-500 focus-visible:ring-offset-2 transition-colors duration-200"
                >
                  {t('cancelar')}
                </button>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </AnimatePresence>
  );
};

export default NewFilePopup;